import { useQuery } from "react-query";
import { getWithdrawalFund } from "../services/getWithdrawalFund";

function useWithdrawalFund(token: string, currency: string, amount: number, totalFee:number) {
  return useQuery(
    ["get-withdrawal-fund", token],
    () => getWithdrawalFund({ token, currency, amount, totalFee}),
    {
      enabled: false,
    }
  );
}

export default useWithdrawalFund;
